import React, { useState, useEffect } from 'react';
import styles from './About.module.css';

const About = () => {
    const [content, setContent] = useState(null);
    const [settings, setSettings] = useState({
        title: 'Обо мне',
        showTitle: true,
        layout: 'text-left'
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadAbout();
    }, []);

    const loadAbout = async () => {
        try {
            const [contentRes, settingsRes] = await Promise.all([
                fetch('/api/content/about?field=content'),
                fetch('/api/content/about?field=settings')
            ]);

            const contentData = await contentRes.json();
            const settingsData = await settingsRes.json();

            setContent(contentData.data || {});
            setSettings(settingsData.data || { title: 'Обо мне', showTitle: true, layout: 'text-left' });
        } catch (error) {
            console.error('Ошибка загрузки:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return null;
    if (!content) return null;

    const paragraphs = content.description ? content.description.split('\n\n') : [];

    return (
        <section id="about" className={styles.about}>
            <div className={styles.container}>
                {settings.showTitle && (
                    <h2 className={styles.title}>{settings.title}</h2>
                )}

                <div className={`${styles.content} ${styles[settings.layout]}`}>
                    <div className={styles.text}>
                        {content.name && (
                            <h3 className={styles.name}>Меня зовут {content.name}</h3>
                        )}
                        {content.experience && (
                            <p className={styles.experience}>Опыт: {content.experience}</p>
                        )}
                        {paragraphs.map((paragraph, idx) => (
                            <p key={idx}>{paragraph}</p>
                        ))}
                    </div>

                    {content.showImage !== false && (content.imageUrl || content.placeholderImage) && (
                        <div className={styles.imageWrapper}>
                            {content.imageUrl ? (
                                <img
                                    src={`${content.imageUrl}`}
                                    alt={content.name || 'Татьяна'}
                                    className={styles.image}
                                />
                            ) : (
                                <div className={styles.placeholder}>
                                    <div className={styles.placeholderEmoji}>👰</div>
                                    <p>Фото мастера</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default About;